var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ObiText',_vm._g(_vm._b({},'ObiText',_vm.attrs,false),_vm.$listeners),[(_vm.checked)?_c('CheckedIcon'):_c('UncheckedIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }